import { AddressBook } from "../../addressBook";
export const DeliveryOptions = () => <AddressBook kind="shipping" />;
